import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getCourse = (id, copy = false) => {
  return dispatch => {
    dispatch({ type: "GET_COURSE_LOADING" });
    api
      .courseGet(id)
      .then(({ data }) => {
        if (copy) {
          delete data.courseId;
          delete data.personId;
          delete data.attachments;
        }
        dispatch(operationSucceeded(data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchCourseErrorAlertTitle",
          "Virhe muun koulutuksen lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_COURSE_SUCCEEDED",
  payload: { course: data },
});

const operationFail = () => ({
  type: "GET_COURSE_FAIL",
});
